import RegulatoryIntelligenceDetailsTemplate from "../../templates/RegulatoryIntelligenceDetailsTemplate/RegulatoryIntelligenceDetailsTemplate";
import useFetch from "../../../hooks/useFetch";
import { regulatoryIntelligenceRepository } from "../../../repository/regulatoryIntelligence.repository";
import { useContext, useEffect } from "react";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import { PostContext } from "../../../contexts/PostContext";

const RegulatoryIntelligenceDetails = ({ match }) => {
  const { data, fetchData, resetData } = useFetch();
  const { isResponseOk } = useContext(PostContext);

  useDocumentTitleLoading();

  useEffect(() => {
    if (isResponseOk || !data) {
      fetchData(regulatoryIntelligenceRepository.getArticle(match.params.id));
    }
  }, [isResponseOk]);

  // Handle picking search result
  useEffect(() => {
    if (data) {
      resetData();
      fetchData(regulatoryIntelligenceRepository.getArticle(match.params.id));
    }
  }, [match.params.id]);

  return data ? (
    <RegulatoryIntelligenceDetailsTemplate data={data} />
  ) : (
    <Loader />
  );
};

export default RegulatoryIntelligenceDetails;
